export default "__VITE_ASSET__DgNPXge2__"